import { useEffect } from "react";
import { useAtomValue, useSetAtom, useStore } from "jotai";
import { useSnackbar } from "notistack";
import { backendGet } from "@accredo/fe-shared/services/dataService.js";
import { claimCostTypesAtom } from "../atoms/claimCostTypesAtom.js";

/**
 * The cost type configuration from the backend, fetched once and shared by
 * every consumer. `config` is null while it is loading or after a failed
 * fetch (`isError`); `reload` retries.
 */
export function useClaimCostTypes() {
  const store = useStore();
  const state = useAtomValue(claimCostTypesAtom);
  const setState = useSetAtom(claimCostTypesAtom);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (store.get(claimCostTypesAtom).status !== "idle") {
      return;
    }
    setState({ status: "loading", data: null });

    backendGet("/data/claim-cost-types", {
      label: "Kostenarten",
      enqueueSnackbar,
    }).then((result) => {
      setState(
        result?.data
          ? { status: "loaded", data: result.data }
          : { status: "error", data: null }
      );
    });
  }, [store, state.status, setState, enqueueSnackbar]);

  return {
    config: state.data,
    isLoading: state.status !== "error" && state.data === null,
    isError: state.status === "error",
    reload: () => setState({ status: "idle", data: null }),
  };
}
